import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75.35 75.35">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            d="M37.67 0a37.68 37.68 0 1037.68 37.67A37.71 37.71 0 0037.67 0z"
            className="cls-1"
            fill="#046880"
          ></path>
          <path
            d="M56.77 29.69L36.36 50.1a3.14 3.14 0 01-4.44 0l-10.2-10.21a3.14 3.14 0 114.44-4.44l8 8 18.17-18.2a3.14 3.14 0 014.44 4.44z"
            className="cls-2"
            fill="#fafafa"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
